'use client'

import { Image } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { getFingerprint } from '@marketplace-web/session-management/audit-util'
import {
  ElectronicsLandingPageEvent,
  ElectronicsDiscoverSectionCardModel,
  landingPageEvent,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import useElectronicsLpVersion from '../../hooks/useElectronicsLpVersion'

const DiscoverSectionCard = ({ imageUrl, title, linkUrl }: ElectronicsDiscoverSectionCardModel) => {
  const { track } = useTracking()
  const lpVersion = useElectronicsLpVersion()

  const handleOnLinkClick = async () =>
    track(
      landingPageEvent({
        event:
          lpVersion === 'buy'
            ? ElectronicsLandingPageEvent.BuyDiscoverSubcategoryLinkClick
            : ElectronicsLandingPageEvent.SellDiscoverSubcategoryLinkClick,
        targetDetails: linkUrl,
        deviceId: await getFingerprint(),
      }),
    )

  return (
    <a
      href={linkUrl}
      className="electronics__discover-card"
      data-testid="electronics-discover-card"
      onClick={handleOnLinkClick}
    >
      <div className="electronics__discover-card-image">
        <Image src={imageUrl} scaling={Image.Scaling.Cover} loading="lazy" />
      </div>
      <p className="electronics__discover-card-title">{title}</p>
    </a>
  )
}

export default DiscoverSectionCard
